// extracted by mini-css-extract-plugin
module.exports = {"container":"landing-module--container--1J4Og"};